const EventLogoEdit = {
  initialize() {
    return $("#event_logo").on("change", function() {
      if ($(this).val() === "") {
        return $(".save-button-js").attr("disabled", "disabled")
      } else {
        return $(".save-button-js").removeAttr("disabled")
      }
    })
  }
}

export default EventLogoEdit
